<div class="m-stack m-stack--ver m-stack--general">
	<div class="m-stack__item m-stack__item--middle m-brand__logo">
		<a routerLink="/" class="m-brand__logo-wrapper">
			<img *ngIf="customerSerivce.settings.name == 'ard'" alt="LOGO" class="octo-logo"
				[attr.src]="'assets/app/media/img/logos/turkdefter_logo_white.png'" />
			<img *ngIf="customerSerivce.settings.name == 'sef'" alt="LOGO" class="octo-logo"
				[attr.src]="'assets/app/media/img/logos/sef.png'" />
			<img *ngIf="customerSerivce.settings.name == 'esnaf'" alt="LOGO" class="octo-logo"
				[attr.src]="'assets/app/media/img/logos/esnaf_logo.png'" />
			<img *ngIf="customerSerivce.settings.name == 'unidoxstyle'" alt="LOGO" class="octo-logo"
				[attr.src]="'assets/app/media/img/logos/unidox_logo_white.png'" />
		</a>
	</div>
	<div class="m-stack__item m-stack__item--middle m-brand__tools">
		<a *ngIf="menuAsideMinimizToggle" href="javascript:;"
			[ngClass]="{ 'm-brand__toggler--active': menuAsideMinimizeDefault }" mMenuAsideToggle
			id="m_aside_left_minimize_toggle"
			class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-desktop-inline-block">
			<span></span>
		</a>
		<a *ngIf="menuAsideDisplay" href="javascript:;" id="m_aside_left_offcanvas_toggle"
			class="m-brand__icon m-brand__toggler m-brand__toggler--left m--visible-tablet-and-mobile-inline-block">
			<span></span>
		</a>
		<a id="m_aside_header_topbar_mobile_toggle" (click)="clickTopbarToggle($event)" href="javascript:;"
			class="m-brand__icon m--visible-tablet-and-mobile-inline-block">
			<i class="flaticon-more"></i>
		</a>
	</div>
</div>